import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPlus, FaSearch, FaTable, FaQrcode, FaUsers } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import moment from 'moment';
import ReactSelect from '../../components/ReactSelect';
import { toast } from 'react-toastify';
import { FinField } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';

const PERFIS_PERGUNTA = ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp', 'qa'];

export default function PainelEventoPergunta() {
    const PAGE_SIZE_DEFAULT = 20;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({});
    const [buscando, setBuscando] = useState(false);
    const [eventos, setEventos] = useState([]);
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        total: 0,
    });
    const controllerRef = useRef(null);
    const params = new URLSearchParams(window.location.search);
    const idEvento = params.get('idEvento');

    const buscar = ({ page = pagination.page, pageSize = pagination.pageSize } = {}) => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setSelectedIds(new Set());
        setBuscando(true);
        api({
            method: 'get',
            action: '/evento',
            token: token,
            params: {
                ...filtro,
                situacao: ['ativo', 'fechado', 'cancelado'],
                perfil: perfil,
                sistemaPergunta: 'sim',
                id: idEvento,
                page: page,
                pageSize: pageSize
            },
            signal: controllerRef.current.signal
        })
            .then(response => {
                setEventos(response.data.data);
                setPagination({
                    page: response.data.page ?? page,
                    pageSize: response.data.pageSize ?? pageSize,
                    total: response.data.total ?? (response.data.data || []).length,
                });
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
                //console.log(err)
            });
    };

    useEffect(() => { //onload
        buscar({ page: 1 });
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    const toggleSelect = (id) => setSelectedIds(prev => {
        const n = new Set(prev);
        n.has(id) ? n.delete(id) : n.add(id);
        return n;
    });
    const toggleAll = () => eventos.length > 0 && selectedIds.size === eventos.length
        ? setSelectedIds(new Set())
        : setSelectedIds(new Set(eventos.map(r => r.id)));

    const total = pagination.total;
    const totalPaginas = Math.max(1, Math.ceil(total / pagination.pageSize));
    const selectedArr = [...selectedIds];
    const selectedRow = selectedArr.length === 1 ? eventos.find(r => r.id === selectedArr[0]) : null;

    const formatarData = (row) => {
        var dataCompetencia = row.dataCompetencia ? " " + moment(row.dataCompetencia).format("MM/YYYY") : "";
        var dataInicio = row.data ? " " + moment(row.data).format("DD/MM/YYYY") : "";
        dataInicio = row.replanejadoInicio ? " " + moment(row.replanejadoInicio).format("DD/MM/YYYY") : dataInicio;
        var dataFim = row.dataFim ? " " + moment(row.dataFim).format("DD/MM/YYYY") : "";
        dataFim = row.replanejadoFim ? " " + moment(row.replanejadoFim).format("DD/MM/YYYY") : dataFim;
        var dataCancelamento = row.dataCancelamento ? " Cancelado: " + moment(row.dataCancelamento).format("DD/MM/YYYY") : "";
        var dataFechamento = row.dataFechamento ? " Fechado: " + moment(row.dataFechamento).format("DD/MM/YYYY") : "";
        if (dataInicio === dataFim) {
            return dataCompetencia + dataInicio + dataFechamento + dataCancelamento;
        } else {
            return dataCompetencia + dataInicio + dataFim + dataFechamento + dataCancelamento;
        }
    };

    const formatarCliente = (row) => {
        if (row.cliente) {
            if (row.cliente?.enderecomunicipio) {
                return row.cliente.codigo + ' - ' + row.cliente.nome + ' - ' + row.cliente.enderecomunicipio.nome + ' - ' + row.cliente.enderecomunicipio.uf;
            } else {
                return row.cliente.codigo + ' - ' + row.cliente.nome;
            }
        }
        return "";
    };

    const toggleSistemaPergunta = (row) => {
        row.sistemaPergunta = row.sistemaPergunta === 'sim' ? 'nao' : 'sim';
        api({
            method: 'post',
            action: '/evento/liberacaoDepartamento/' + row.id,
            token: token,
            data: {
                departamento: 'sistemaPergunta',
                situacao: row.sistemaPergunta,
            }
        })
            .then(function (response) {
                //alert("Evento cancelado com sucesso!");
            })
            .catch(function (error) {
                row.sistemaPergunta = row.sistemaPergunta === 'sim' ? 'nao' : 'sim';
                setEventos([...eventos]);
                toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
            });
        setEventos([...eventos]);
    };

    return (
        <ErpTemplate sidebar={['listarsvp'].includes(perfil) ? false : true}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Eventos</h1></div>
                    <div className="fin-pp__actions">
                        {['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) && (
                            <Link to="/cadastroEventoPergunta" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                                <FaPlus size={14} /> Novo Evento
                            </Link>
                        )}
                    </div>
                </div>

                <form className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }} onSubmit={e => { buscar({ page: 1 }); e.preventDefault(); }}>
                    <div className="fin-pp__filters">
                        <FinField label="Cliente" full>
                            <ReactSelect
                                id="cliente"
                                value={{ value: filtro.cliente, label: filtro.nomeCliente }}
                                onChange={e => setFiltro({ ...filtro, ...{ "cliente": e.value, "nomeCliente": e.label } })}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/participante',
                                        token: token,
                                        params: {
                                            nome: input,
                                            tipoCadastro: "cliente",
                                            situacaoRegistro: "ativo",
                                        }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                var label = registro.codigo +
                                                    ' - ' + registro.nome +
                                                    (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                    (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                    (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                    (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                return { value: registro.id, label: label };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </FinField>
                        <FinField label="Nome do Evento" full>
                            <input
                                autoFocus
                                type="text"
                                className="fin-pp__input"
                                style={{ paddingLeft: 14 }}
                                placeholder="Buscar pelo nome do evento"
                                onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                            />
                        </FinField>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                            <FaSearch size={14} /> {buscando ? 'Buscando...' : 'Buscar'}
                        </button>
                    </div>
                </form>

                {selectedRow && PERFIS_PERGUNTA.includes(perfil) && (
                    <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/evento/exportarPerguntas"} style={{ display: 'inline' }}>
                            {/* exportarPerguntas faz json_decode($request->data): tudo vai num único
                                campo "data", como nos demais exports (ver PainelEventoParticipante) */}
                            <input type="hidden" name="data" value={JSON.stringify({ token: localStorage.getItem('token'), idEvento: selectedRow.id })} />
                            <button type="submit" className="fin-pp__btn fin-pp__btn--sm">
                                <FaTable size={14} /> Relatório
                            </button>
                        </form>
                        <Link to={"/eventoPerguntaQrCode/" + selectedRow.id} className="fin-pp__btn fin-pp__btn--sm">
                            <FaQrcode size={14} /> QrCodes
                        </Link>
                        <Link to={"/eventoPalestrante/" + selectedRow.id} className="fin-pp__btn fin-pp__btn--sm">
                            <FaUsers size={14} /> Palestrantes
                        </Link>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto', minWidth: 900 }}>
                            <thead>
                                <tr>
                                    {!['listarsvp'].includes(perfil) && (
                                        <th style={{ width: 40 }}>
                                            <input
                                                type="checkbox"
                                                checked={eventos.length > 0 && selectedIds.size === eventos.length}
                                                onChange={toggleAll}
                                            />
                                        </th>
                                    )}
                                    <th style={{ width: 60 }}>Q&A</th>
                                    <th style={{ width: 80, textAlign: 'right' }}>Código</th>
                                    <th style={{ width: 90 }}>Situação</th>
                                    <th style={{ width: 120 }}>Identificação</th>
                                    <th>Nome do Evento</th>
                                    <th>Cliente</th>
                                    <th style={{ width: 140 }}>Data</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando ? (
                                    <tr><td colSpan={8} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                ) : eventos.length === 0 ? (
                                    <tr><td colSpan={8} className="fin-pp__empty">Nenhum registro</td></tr>
                                ) : eventos.map(row => (
                                    <tr key={row.id}>
                                        {!['listarsvp'].includes(perfil) && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds.has(row.id)}
                                                    onChange={() => toggleSelect(row.id)}
                                                />
                                            </td>
                                        )}
                                        <td>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={row.sistemaPergunta === 'sim'}
                                                    onChange={() => toggleSistemaPergunta(row)}
                                                />
                                            </div>
                                        </td>
                                        <td style={{ textAlign: 'right' }}>{row.codigo ?? ""}</td>
                                        <td>{row.situacao ?? ""}</td>
                                        <td>{row.identificacao ?? ""}</td>
                                        <td className="fin-pp__cell-strong">{row.nome}</td>
                                        <td className="fin-pp__cell-muted">{formatarCliente(row)}</td>
                                        <td>{formatarData(row)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select
                                className="fin-pp__select"
                                style={{ height: 34 }}
                                value={pagination.pageSize}
                                onChange={e => buscar({ page: 1, pageSize: Number(e.target.value) })}
                            >
                                <option value={10}>10 / pág</option>
                                <option value={20}>20 / pág</option>
                                <option value={50}>50 / pág</option>
                                <option value={100}>100 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={pagination.page <= 1} onClick={() => buscar({ page: pagination.page - 1 })}>Anterior</button>
                            <span className="fin-pp__pagination-info">{pagination.page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={pagination.page >= totalPaginas} onClick={() => buscar({ page: pagination.page + 1 })}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
